export interface ToolInfo {
  slug: string
  name: string
  description: string
  href: string
}

export const tools: Record<string, ToolInfo> = {
  "merge-pdf": {
    slug: "merge-pdf",
    name: "Merge PDF",
    description: "Combine multiple PDFs into one",
    href: "/merge-pdf",
  },
  "split-pdf": {
    slug: "split-pdf",
    name: "Split PDF",
    description: "Extract pages from a PDF",
    href: "/split-pdf",
  },
  "reorder-pdf": {
    slug: "reorder-pdf",
    name: "Reorder PDF",
    description: "Rearrange PDF pages",
    href: "/reorder-pdf",
  },
  "protect-pdf": {
    slug: "protect-pdf",
    name: "Protect PDF",
    description: "Add password protection",
    href: "/protect-pdf",
  },
  "sign-pdf": {
    slug: "sign-pdf",
    name: "Sign PDF",
    description: "Add your signature",
    href: "/sign-pdf",
  },
  "image-to-pdf": {
    slug: "image-to-pdf",
    name: "Image to PDF",
    description: "Convert images to PDF",
    href: "/image-to-pdf",
  },
  "jpg-to-pdf": {
    slug: "jpg-to-pdf",
    name: "JPG to PDF",
    description: "Convert JPG images to PDF",
    href: "/jpg-to-pdf",
  },
  "png-to-pdf": {
    slug: "png-to-pdf",
    name: "PNG to PDF",
    description: "Convert PNG images to PDF",
    href: "/png-to-pdf",
  },
}

export const toolRelationships: Record<string, string[]> = {
  "merge-pdf": ["split-pdf", "reorder-pdf"],
  "split-pdf": ["merge-pdf", "reorder-pdf"],
  "reorder-pdf": ["merge-pdf", "split-pdf"],
  "protect-pdf": ["sign-pdf", "merge-pdf"],
  "sign-pdf": ["protect-pdf", "merge-pdf"],
  "image-to-pdf": ["jpg-to-pdf", "png-to-pdf"],
  "jpg-to-pdf": ["png-to-pdf", "image-to-pdf"],
  "png-to-pdf": ["jpg-to-pdf", "image-to-pdf"],
}

export function getRelatedTools(currentSlug: string): ToolInfo[] {
  const related = toolRelationships[currentSlug] || []
  return related.map((slug) => tools[slug]).filter(Boolean)
}
